<template>
	<div>
		<b-row>
			<b-col cols="6">
				<b-card class="shadow">
					<highcharts :options="optionsremaning" style="margin-top: 40px"></highcharts>
				</b-card>
			</b-col>
			<b-col cols="6">
				<b-card class="shadow">
					<highcharts :options="optin" style="margin-top: 40px"></highcharts>
				</b-card>
			</b-col>
		</b-row>
	</div>
</template>

<script>
import {Chart} from 'highcharts-vue'
export default {
	name: "Remaining",
	components: {
		highcharts: Chart
	},
	data() {
		return {}
	},
	props: ['remaining', 'saleSum'],
	computed: {
		remaining1() {
			let list = []
			if (list.length === 0) {
				for (const listKey in this.remaining) {
					let obj = []
					obj.push(this.remaining[listKey].departmentName)
					obj.push(this.remaining[listKey].value)
					list.push(obj)
					obj = []
				}
				return list
			}
		},
		optionsremaning() {
			return {
				chart: {
					type: 'pie',
					options3d: {
						enabled: true,
						alpha: 45
					}
				},
				title: {
					text: '<b style="color:rgb(0 158 203) ">СУММА ТЕКУЩЕГО ОСТАТКА</b><br>',
					align: 'center'
				},
				plotOptions: {
					pie: {
						innerSize: 100,
						depth: 45
					}
				},
				series: [{
					name: 'DUTYFREE',
					data: this.remaining1
				}]
			}
		},
		saleSum1() {
			let list = []
			if (list.length === 0) {
				for (const listKey in this.saleSum) {
					let obj = []
					obj.push(this.saleSum[listKey].value)
					list.push(obj)
					obj = []
				}
				return list
			}
		},
		saleSum2() {
			let list = []
			if (list.length === 0) {
				for (const listKey in this.saleSum) {
					let obj = []
					obj.push(this.saleSum[listKey].departmentName)
					list.push(obj)
					obj = []
				}
				return list
			}
		},
		optin() {
			return {
				chart: {
					type: 'column'
				},
				title: {
					text: '<b style="color: #8060a5">Сумма вчерашних продаж</b>'
				},
				tooltip: {
					shared: true
				},
				xAxis: {
					categories: this.saleSum2,
					// crosshair: true
				},
				yAxis: [{
					title: {
						text: ''
					}
				}, {
					title: {
						text: ''
					},
					minPadding: 0,
					maxPadding: 0,
					max: 100,
					min: 0,
					opposite: true,
					// labels: {
					// 	format: '{value}'
					// }
				}],
				series: [
				// 	{
				// 	type: 'pareto',
				// 	name: ' ',
				// 	yAxis: 1,
				// 	zIndex: 10,
				// 	baseSeries: 1,
				// 	// tooltip: {
				// 	// 	valueDecimals: 2,
				// 	// 	valueSuffix: '%'
				// 	// }
				// },
					{
					name: ' ',
					type: 'column',
					zIndex: 2,
					data: this.saleSum1
				}]
			}
		}
	},
}
</script>
<style scoped>
.c-dashboardInfo {
	margin-bottom: 15px;
}

.c-dashboardInfo .wrap {
	background: #ffffff;
	box-shadow: 2px 10px 20px rgba(0, 0, 0, 0.1);
	border-radius: 7px;
	position: relative;
	overflow: hidden;
	padding: 18px 5px 5px;
	height: 100%;
}

.c-dashboardInfo__title {
	color: #6c6c6c;
	font-size: 13px;
	font-weight: 900;
	text-align: center;
}

.c-dashboardInfo span {
	display: block;
}

.c-dashboardInfo__count {
	font-weight: bold;
	font-size: 15px;
	color: #323c43;
}

.c-dashboardInfo .wrap:after {
	display: block;
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 10px;
	content: "";
}

.c-dashboardInfo:nth-child(1) .wrap:after {
	background: linear-gradient(82.59deg, #00c48c 0%, #00a173 100%);
}

.c-dashboardInfo:nth-child(2) .wrap:after {
	background: linear-gradient(81.67deg, #0084f4 0%, #1a4da2 100%);
}

.c-dashboardInfo:nth-child(3) .wrap:after {
	background: linear-gradient(69.83deg, #0084f4 0%, #00c48c 100%);
}

.c-dashboardInfo:nth-child(4) .wrap:after {
	background: linear-gradient(81.67deg, #ff647c 0%, #1f5dc5 100%);
}

.c-dashboardInfo__title svg {
	color: #d7d7d7;
	margin-left: 5px;
}

.MuiSvgIcon-root-19 {
	fill: currentColor;
	width: 1em;
	height: 1em;
	display: inline-block;
	font-size: 24px;
	transition: fill 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
	user-select: none;
	flex-shrink: 0;
}

</style>
